"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDkimEnabled = exports.activeIntegration = exports.isActiveServiceLoaded = exports.integrationsIsLoading = exports.pathToEmailIntegrations = void 0;

var _reselect = require("reselect");

var _ramda = require("ramda");

var pathToEmailIntegrations = (0, _ramda.path)(['personalIntegration', 'personalIntegration']);
exports.pathToEmailIntegrations = pathToEmailIntegrations;
var integrationsIsLoading = (0, _ramda.compose)((0, _ramda.prop)('isLoading'), pathToEmailIntegrations);
exports.integrationsIsLoading = integrationsIsLoading;
var isActiveServiceLoaded = (0, _ramda.compose)((0, _ramda.prop)('isLoaded'), pathToEmailIntegrations);
exports.isActiveServiceLoaded = isActiveServiceLoaded;
var activeIntegration = (0, _reselect.createSelector)(pathToEmailIntegrations, function (module) {
  return module.activeIntegration;
});
exports.activeIntegration = activeIntegration;
var isDkimEnabled = (0, _reselect.createSelector)(pathToEmailIntegrations, function (module) {
  return module.usingDkim;
});
exports.isDkimEnabled = isDkimEnabled;